import { render, staticRenderFns } from "./YXB.vue?vue&type=template&id=77cc3710&scoped=true&"
import script from "./YXB.vue?vue&type=script&lang=js&"
export * from "./YXB.vue?vue&type=script&lang=js&"
import style0 from "./YXB.vue?vue&type=style&index=0&id=77cc3710&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77cc3710",
  null
  
)

export default component.exports